// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"406f89d7","667":"b5bfa5e2","977":"3dbdc4ed"}[chunkId] + ".chunk.js";
};